import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerShift } from './models';
import { invalidateVolunteerShifts } from './useVolunteerShifts';

export const useCreateVolunteerShiftMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerShift) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			activityId,
			shift,
			impersonationContext,
		}: {
			activityId: string;
			shift: Partial<IVolunteerShift>;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerShift>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/activities/${activityId}/shifts`,
				}),
				'POST',
				shift
			),
		onSuccess: (data, variables) => {
			invalidateVolunteerShifts(variables.activityId);
			onSuccess?.(data);
		},
		onError,
	});
};
